import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IGroupReq } from '../../../models/groups.model'
import { doCreateGroup } from '../../../store/group.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';
import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/system/group/Editor';
import { errorVariant, successVariant, warningVariant } from '../../../lib/barVariant';

const SystemGroupCreate: FC = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state: RootState) => state.group);

  const onSubmit = async (req: IGroupReq) => {
    const res = await dispatch(doCreateGroup(req));
    
    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.create'), successVariant);
        history.push('/system/group');
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.group.title2')}
      />
      <Editor
        group={null}
        onSubmit={onSubmit}
      />
      <Footer />
    </div>
  )
}

export default SystemGroupCreate;
